import { render, staticRenderFns } from "./rightMenu.vue?vue&type=template&id=493a079a&scoped=true"
import script from "./rightMenu.vue?vue&type=script&lang=js"
export * from "./rightMenu.vue?vue&type=script&lang=js"
import style0 from "./rightMenu.vue?vue&type=style&index=0&id=493a079a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a079a",
  null
  
)

export default component.exports